import React from 'react'
import Skeleton from '@material-ui/lab/Skeleton'
import { makeStyles } from '@material-ui/core/styles'
import {
    METHOD_BG,
    METHOD_BORDER,
    METHOD_PADDING,
    METHOD_RADIUS,
    METHOD_SHADOW,
    METHOD_SPACING,
} from '../checkoutAppearance'

// Shaped like the Payment Element's accordion rows (same tokens the rows are drawn from), so the
// panel does not resize when the real element swaps in. Shown from first paint until the element
// reports ready — Stripe's own loader is off (loader: 'never'), because it only appears after the
// session round trip, which read as a blank card followed by a second loading state.
const useStyles = makeStyles(() => ({
    srOnly: {
        position: 'absolute',
        width: 1,
        height: 1,
        overflow: 'hidden',
        clip: 'rect(0 0 0 0)',
        whiteSpace: 'nowrap',
    },
    row: {
        marginTop: METHOD_SPACING,
        backgroundColor: METHOD_BG,
        border: `1px solid ${METHOD_BORDER}`,
        borderRadius: METHOD_RADIUS,
        boxShadow: METHOD_SHADOW,
        padding: METHOD_PADDING,
        display: 'flex',
        alignItems: 'center',
    },
    icon: {
        marginRight: 12,
    },
    fields: {
        marginTop: METHOD_SPACING,
    },
}))

const PaymentFormSkeleton = () => {
    const classes = useStyles()

    return (
        <div role="status" data-testid="payment-form-skeleton">
            <span className={classes.srOnly}>Loading payment options</span>
            {[0, 1, 2].map((row) => (
                <div className={classes.row} key={row}>
                    <Skeleton
                        variant="circle"
                        width={22}
                        height={22}
                        className={classes.icon}
                    />
                    <Skeleton variant="text" width={row === 0 ? 120 : 96} />
                </div>
            ))}
            <div className={classes.fields}>
                <Skeleton variant="rect" height={44} style={{ borderRadius: 8 }} />
                <Skeleton
                    variant="rect"
                    height={44}
                    style={{ borderRadius: 8, marginTop: 12 }}
                />
            </div>
        </div>
    )
}

export default PaymentFormSkeleton
